import {connect} from 'react-redux';
import FinanceHome from './FinanceHome.jsx'; 
import {
    selectFinanceTab
} from './actionTypes';

const mapStateToProps = state => ({ 
  actions: state.finance.base.financeActions,
  selectedAction: state.finance.base.financeActions.find(a => a.active)
});

const mapDispatchToProps = dispatch => ({ 
  onSelectFinanceTab: (financeTab) => dispatch(selectFinanceTab(financeTab))
});

export default connect(mapStateToProps, mapDispatchToProps)(FinanceHome);



// WEBPACK FOOTER //
// ./src/features/finance/FinanceHomeContainer.jsx